import { create } from 'zustand';

interface ResponsiveStore {
  isMobile: boolean;
  isTabletSmall: boolean;
  isTablet: boolean;
  isTabletLarge: boolean;
  isDesktop: boolean;
  isDesktopLarge: boolean;
  updateResponsiveFlags: (width: number) => void;
}

const useResponsiveStore = create<ResponsiveStore>((set) => ({
  isMobile: false,
  isTablet: false,
  isTabletSmall: false,
  isTabletLarge: false,
  isDesktop: false,
  isDesktopLarge: false,

  updateResponsiveFlags: (width: number) => {
    set({
      isMobile: width < 600,
      isTablet: width >= 600 && width < 1024,
      isTabletSmall: width >= 600 && width < 768,
      isTabletLarge: width >= 768 && width < 1024,
      isDesktop: width >= 1024,
      isDesktopLarge: width >= 1200,
    });
  },
}));

export default useResponsiveStore;
